var render = function render(_c,_vm){return _c('ul',{staticClass:"v-list"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }